<template>
  <default-layout>
    <div class="l-main-layout">
      <div class="l-main-layout__sidebar">
        <Nav />
        <!-- <div class="l-main-layout__sidebar__ask-atto">
          <AskAtto />
        </div> -->
      </div>

      <div class="l-main-layout__main" :key="categoryId">
        <section class="actions">
          <div class="picker">
            <span>Colour</span>
            <i class="icon icon--gamma" :class="colour == 'gamma' ? 'active' : ''" @click="colour = 'gamma'"></i>
            <i class="icon icon--zeta" :class="colour == 'zeta' ? 'active' : ''" @click="colour = 'zeta'"></i>
            <i class="icon icon--epsilon" :class="colour == 'epsilon' ? 'active' : ''" @click="colour = 'epsilon'"></i>
            <i class="icon icon--original" :class="colour == '' ? 'active' : ''" @click="colour = ''"></i>
          </div>
          <div class="add" v-if="store.role == 'admin'">
            <input v-if="uploadReady" type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
            <button class="button button--white button--add" v-on:click="addFiles()" :disabled="!categoryId">Add Files</button>
          </div>
        </section>

        <section v-if="photographs && photographs.entries">
          <div class="photographs">
            <div class="photograph" :class="selections[photograph.id] ? 'selected' : selected.length > 0 ? 'not-selected' : ''" v-for="photograph in photographs.entries" :key="photograph.id">
              <div class="delete" @click="e => deletePhotograph(e, photograph.id)" v-if="store.role == 'admin'"></div>
              <!-- By Loading all Colour variations, the switching is a lot smoother -->
              <img :src="photograph.thumbUrlGamma"  @click="toggle(photograph.id)" v-show="colour == 'gamma'"/>
              <img :src="photograph.thumbUrlZeta"  @click="toggle(photograph.id)" v-show="colour == 'zeta'"/>
              <img :src="photograph.thumbUrlEpsilon"  @click="toggle(photograph.id)" v-show="colour == 'epsilon'"/>
              <img :src="photograph.thumbUrl"  @click="toggle(photograph.id)" v-show="colour == ''"/>
              <span class="photograph__name">{{photograph.name}}</span>
            </div>
          </div>

          <infinite-loading v-if="infiniteLoadReady" @infinite="infiniteHandler">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
          </infinite-loading>
        </section>


        <div class="download-bar-container" :class="selected.length > 0 ? 'is-visible' : ''">
          <div class="download-bar">
            <div>
              <span class="items">{{ selected.length || 1 }} {{ selected.length > 1 ? "Items" : "Item" }} Selected</span>
              <button class="button button--white-outline" @click="selections = {}">Clear All</button>
            </div>
            <button class="button button--white" @click="download">Download</button>
          </div>
        </div>

      </div>

      <delete-modal :display="display" :left="left" :top="top" @close="display = false" @confirm="confirmDeletePhotograph"></delete-modal>
    </div>
  </default-layout>
</template>

<script>
import Nav from '../components/Nav';
// import AskAtto from '../components/AskAtto';
import Api from '../utils/api';
import DeleteModal from '../components/DeleteModal';
import InfiniteLoading from 'vue-infinite-loading';
import { store } from '../utils/store';
import PhotographsQuery from '../graphql/photographs.js'

export default {
  components: {
    Nav,
    // AskAtto,
    DeleteModal,
    InfiniteLoading
  },

  props: ["categoryId"],

  data() {
    return {
      page: 1,
      pageSize: 24,
      sortField: 'created_at',
      sortOrder: 'desc',
      search: '',
      selections: {},
      left: 0,
      top: 0,
      display: false,
      id: null,
      colour: "",
      uploadReady: true,
      infiniteLoadReady: true,
    }
  },

  computed: {
    selected() {
      return Object.keys(this.selections).filter(s => this.selections[s])
    },
    store() {
      return store;
    }
  },

  apollo: {
    photographs: {
      query: PhotographsQuery,
      variables: {
        page: 1,
        pageSize: 24,
        sortField: 'created_at',
        sortOrder: 'desc',
        search: '',
        categoryId: 0,
        section: 'photographs'
      },
    }
  },

  created () {
    this.reset()
  },

  watch: {
    '$route': 'reset'
  },

  methods: {
    reset() {
      this.page = 1;
      this.$apollo.queries.photographs.setVariables({
        page: 1,
        pageSize: 24,
        sortField: 'created_at',
        sortOrder: 'desc',
        search: '',
        categoryId: parseInt(this.categoryId),
        section: 'photographs'
      })
      this.$apollo.queries.photographs.refetch().then(() => {
        this.infiniteLoadReady = false
        this.$nextTick(() => {
          this.infiniteLoadReady = true
        })
      });
    },


    infiniteHandler($state) {
      if (this.page >= this.photographs.pagesCount) {
        $state.complete();
        return
      }
      this.page += 1
      let vm = this
      this.$apollo.queries.photographs.fetchMore({
        // New variables
        variables: {
          page: vm.page,
          pageSize: vm.pageSize,
          sortField: vm.sortField,
          sortOrder: vm.sortOrder,
          search: vm.search,
          categoryId: parseInt(vm.categoryId),
          section: 'photographs'
        },
        // Transform the previous result with new data
        updateQuery: (previousResult, { fetchMoreResult }) => {
          $state.loaded();

          return {
            photographs: {
              __typename: "PhotographPage",
              entries: [...previousResult.photographs.entries, ...fetchMoreResult.photographs.entries],
              entriesCount: fetchMoreResult.photographs.entriesCount,
              pageSize: fetchMoreResult.photographs.pageSize,
              pagesCount: fetchMoreResult.photographs.pagesCount,
              currentPage: fetchMoreResult.photographs.currentPage,
            },
          }
        },
      })
    },
    toggle(id) {
      this.$set(this.selections, id, !this.selections[id])
    },
    download() {
      let loader = this.$loading.show()
      let vm = this;
      Api.get(`/download/photographs`, {
        method: 'GET',
        responseType: 'blob', // important
        params: {
          photograph_ids: this.selected.join(","),
          colour: this.colour,
        }
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the filename
        let filename = "";
        if (vm.selected.length > 1) {
          const d = new Date()
          filename = `photographs-${d.getFullYear()}-${d.getMonth()}-${d.getDay()}-${d.getHours()}-${d.getMinutes()}.zip`
        } else {
          const photograph = vm.photographs.entries.find(p => p.id == vm.selected[0])
          filename = photograph.filename
        }

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        loader.hide()
        // clear selections after download
        vm.selections = {}
      })
      .catch(error => {
        console.log(error)
        alert("Sorry, something went wrong")
        loader.hide()
      })
    },

    // We rely on the files input field change, if they re-upload the same file it won't change and the change won't fire
    // this resets the form after an upload
    clearFiles() {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    addFiles() {
      this.$refs.files.click()
    },
    handleFilesUpload(){
      var files = this.$refs.files.files;
      if (files.length == 0)
        return

      let loader = this.$loading.show()

      let formData = new FormData();
      formData.append('category_id', this.categoryId);
      formData.append('section', 'photographs');
      for( var i = 0; i < files.length; i++ ){
        let file = files[i];
        formData.append('files[]', file);

      }
      let vm = this
      Api.post('/photographs',
        formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function(){
          vm.page = 1
          vm.$apollo.queries.photographs.refetch()
          vm.clearFiles()
          loader.hide()
        })
        .catch(function(){
          loader.hide()
        });
    },
    deletePhotograph(event, id) {
      if (this.display) {
        this.display = false
      } else {
        this.id = id;
        this.display = true
        this.left = event.target.getBoundingClientRect().left+44;
        this.top = event.target.getBoundingClientRect().top;
      }
    },
    confirmDeletePhotograph() {
      let vm = this;
      this.display = false
      Api.delete(`/photographs/${this.id}`)
        .then(function(){
          vm.$apollo.queries.photographs.refetch()
        })
        .catch(function(){
          window.alert("Sorry, something went wrong")
        });
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/mixins';


  .actions {
    display: flex;
    justify-content: space-between;
    padding: 87px;
    @include bp(680px) {
      padding: 28px;
    }

    padding-bottom: 0px;
    border-bottom: 0px;

    .picker {
      display:flex;
      align-items: center;

      span {
        margin-right: 12px;
        font-size: 14px;
        font-family: var(--f-bold);
        color: black;
      }
      .icon {
        margin-left: 12px;
        padding-bottom: 35px;
        border-bottom: 2px solid #f7f8f9;
        cursor: pointer;

        &.active {
          border-bottom: 2px solid #DFA9FF;
        }
      }
    }

    .add {
      @include bp(680px) {
        display: none;
      }
    }

  }




  .photographs {
    display: grid;
    justify-content: start;
    grid-column-gap: 16px;
    grid-row-gap: 50px;

    grid-template-columns: repeat( auto-fill, 300px );

    // grid-template-columns: 300px 300px 300px 300px;

    // @include bp(1670px) {
    //   grid-template-columns: 300px 300px 300px;
    // }

    // @include bp(1360px) {
    //   grid-template-columns: 300px 300px;
    // }

    // @include bp(1000px) {
    //   grid-template-columns: 300px;
    // }

  }

  .photograph {
    position: relative;
    width: 300px;
    min-height: 164px;

    &.not-selected:hover {

    }

    &:hover .delete {
      opacity: 1;
    }

    &__name {
      font-family: var(--f-semi);
        font-size: 11px;
        opacity: 0.4;
        margin-top: 13px;
    }

    img {
      cursor: pointer;
      opacity: 1;
      transition: opacity .3s;

    }

    &.selected {
      img {
        outline: 1px solid var(--text-pink);
        opacity: 1;
      }

      .delete {
        opacity: 0;
      }
    }

    &.not-selected {
      img {
        border: none;
        opacity: 0.5;
      }

      &:hover {
        img {
          opacity: 1;
        }
      }
    }

  }

  .download-bar-container {
    padding-left: 300px;
    @include bp(880px) {
      padding-left: 200px;
    }
    @include bp(680px) {
      padding-left: 0px;
    }
    position: fixed;
    bottom: 0;
    left: 0;
    right:0;
    transform: translateY(100%);
    transition: transform .4s;

    &.is-visible {
      transform: translateY(0);
    }

    .download-bar {
      width: 100%;
      background: #3256FF;
      padding: 17px 30px;
      color: white;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .items {
        font-family: var(--f-bold);
        font-size: 14px;
        margin-right: 20px;
      }

    }
  }

  input[type="file"]{
    position: absolute;
    top: -9000px;
    left: -9000px;
  }

  .delete {
    opacity: 0;
    transition: opacity .3s;
    position: absolute;
    top: 0%;
    left: 100%;
    transform: translate(-100%, 0%);
    width: 44px;
    height: 44px;
    background-color: var(--white);
    background-image: url('../assets/images/icons/icon--cross.svg');
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 9px;
    cursor: pointer;
    z-index: 950;

    @include bp(680px) {
      display: none;
    }
  }
</style>
